module.exports = __webpack_public_path__ + "img/mushamaru_3.2699343c.png";